import { CampaignTreeModel } from "../models/CampaignTreeModel";

export function updateTreeTotal(tree: CampaignTreeModel, neededTreeship: boolean,
    isTargetNeighborhood: boolean): number {

    tree.cost1 = locationCost(tree, 1, neededTreeship, isTargetNeighborhood);
    tree.cost2 = locationCost(tree, 2, neededTreeship, isTargetNeighborhood);
    tree.cost3 = locationCost(tree, 3, neededTreeship, isTargetNeighborhood);
    tree.cost4 = locationCost(tree, 4, neededTreeship, isTargetNeighborhood);

    tree.total = tree.qty1 * tree.cost1
        + tree.qty2 * tree.cost2
        + tree.qty3 * tree.cost3
        + tree.qty4 * tree.cost4;

    return tree.total;
}

export function locationCost(ctree: CampaignTreeModel, location: number,
    neededTreeship: boolean, isTargetNeighborhood: boolean): number {
    let cost = 0;
    if (neededTreeship) {
        return cost;
    }

    if (isTargetNeighborhood) {
        switch (location) {
            case 1:
                cost = ctree.location1TargetCost;
                break;
            case 2:
                cost = ctree.location2TargetCost;
                break;
            case 3:
                cost = ctree.location3TargetCost;
                break;
            case 4:
                cost = ctree.location4TargetCost;
                break;
        }
    }
    else {
        switch (location) {
            case 1:
                cost = ctree.location1NormalCost;
                break;
            case 2:
                cost = ctree.location2NormalCost;
                break;
            case 3:
                cost = ctree.location3NormalCost;
                break;
            case 4:
                cost = ctree.location4NormalCost;
                break;
        }
    }
    return cost;
}